// Error class abstraction that enables framework agnostic error handling
export class WebApiRequestCancellationError extends Error {
  name = "WebApiRequestCancellationError";
}
